import { SelectOption } from '../globalTypes'
import { Agent } from './types'

export interface AgentOption extends SelectOption {
    agentId: number
    agencyOfficeId?: number
}

/**
 * Formats raw Agent API data into react-select option objects for use in form select inputs.
 */
export const formatAgentOptions = (items?: Agent[]): AgentOption[] => {
    if (!items?.length) return []

    return items.map((item) => ({
        value: item.id.toString(),
        label: `${item.firstName} ${item.lastName}`,
        agentId: item.id,
        agencyOfficeId: item.agencyOffice?.id,
    }))
}
